RivalIQ.apps.Analyze.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ReorderItem = Marionette.ItemView.extend({
        tagName: 'li',
        className: function () {
            const me = this;
            return ['list-group-item thin', me.options.hide ? 'display-none' : ''].join(' ');
        },
        template: '#analyzeReorderItemTemplate',
        attributes: function () {

            const me = this;
            return {
                'data-index': me.getOption('index')
            };
        },
        serializeData: function () {
            const me = this;

            return {
                name: (me.options.hide ? '' : me.model.getTitle())
            };
        }
    });
});
